'use strict';

module.exports = {
  INFO: 'INFO',
  WARN: 'WARNING',
  ERROR: 'ERROR',
  LOG: 'LOG'
};



// WEBPACK FOOTER //
// ./src/main/wixCodeLogLevel.js